import React, { Component } from 'react';
import ErrorBoundary from '../../components/error-boundary';
import DatabaseQuery from '../database/database-query';
import DatabaseConnection from '../database/database-connection';
import AppUserGroups from '../users/app-user-groups';
import DataSource from '../database/data-sources';
import DataDictionary from '../data-dictionary/data-dictionary';
import RuleSets from '../settings/rulesets';
import UserProfileAdmin from '../user-profile-admin/user-profile-admin';
import MyDelegations from '../my-delegations/my-delegations';
import AccessAdmin from '../access-admin/access-admin';
import Auth from '../../auth/auth';
import {Col, Row} from 'react-bootstrap';
import {CONTEXT_ENABLED} from '../../config/features';


const auth = new Auth();
const { getContext, getIsSuperUser, getRoleId } = auth;

const FEATURE_BY_MODULE = {
  connection: 'database_connection',
  query: 'database_query',
  datasource: 'data_source',
  datadictionary: 'data_dictionary_import',
  usergroup: 'user_group',
  rulesets: 'rulesets',
};

class SuperUserPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      appContentContainer:"app-content-container",
      mainPageClass: "page-content select-container in",
      subPageClass: "page-content results-container",
      pageNavContainer:"hide",
      showModule:null,
    };
  }





  componentDidUpdate(prevProps) {
    const prevModule = prevProps.match?.params?.module || null;
    const currentModule = this.props.match?.params?.module || null;

    if (prevModule !== currentModule) {
      if (currentModule) {
        this.setState({
          showModule: currentModule,
          appContentContainer:"app-content-container in",
          mainPageClass: "page-content select-container",
          subPageClass: "page-content results-container in",
          pageNavContainer:"page-nav-container",
        });
      } else {
        this.setState({
          appContentContainer:"app-content-container",
          mainPageClass: "page-content select-container in",
          subPageClass: "page-content results-container",
          pageNavContainer:"hide",
          showModule:null
        });
      }
    }
  }

  componentDidMount() {
    const currentModule = this.props.match?.params?.module || null;
    if (currentModule) {
      this.setState({
        showModule: currentModule,
        appContentContainer:"app-content-container in",
        mainPageClass: "page-content select-container",
        subPageClass: "page-content results-container in",
        pageNavContainer:"page-nav-container",
      });
    }
  }



navigateToBegin=()=>{
  this.setState({
    appContentContainer:"app-content-container",
    mainPageClass: "page-content select-container in",
    subPageClass: "page-content results-container",
    pageNavContainer:"hide"
  });
}


hideBackNavigation=()=>{
  this.setState({
    appContentContainer:"app-content-container",
    pageNavContainer:"hide"
  });
}


  goToTop=()=>{
    document.getElementById("app").scrollTo(0,0);
  }

  dropdownSelector = (name,id,value) => {
              this.setState({[name]:value});
          }

  dismissBanner = () => {
                this.setState({showBanner:false});
         }

 snackHandler = (state) =>{
   this.setState({snackbarStatus:state});
 }







 selectModule=(name)=>{
   if (this.props.history && this.props.history.push) {
     this.props.history.push(`/settings/${name}`);
     return;
   }
   this.setState({
     showModule:name,
     appContentContainer:"app-content-container in",
     mainPageClass: "page-content select-container",
     subPageClass: "page-content results-container in",
     pageNavContainer:"page-nav-container",
   });
 }



  goBack = (level) => {
                    if(level===0){
                      if (this.props.history && this.props.history.push) {
                        this.props.history.push('/settings');
                        return;
                      }
                      this.setState({
                        appContentContainer:"app-content-container",
                        mainPageClass: "page-content select-container in",
                        subPageClass: "page-content results-container",
                        pageNavContainer:"hide",
                        showModule:null
                      });
                    } else if (level===1){
                      this.setState({
                        pageNavContainer:"page-nav-container"
                      });
                    } else if (level===2){
                      this.setState({
                        pageNavContainer:"hide"
                      });
                    }
                }


  canAccess = (moduleName) => {
    switch (moduleName) {
      case 'delegations':      return true;
      case 'userprofileadmin': return getIsSuperUser();
      // Explicit case, not the default branch (docs/access/slice-4b-admin-surface-plan.md §3.2):
      // the default also admits legacy roleId===1, which would silently widen this tile to every
      // pre-RBAC "Technical user" admin rather than only real super users.
      // Unpadded deliberately: the siblings' column alignment is ESLint no-multi-spaces debt, and
      // matching it would mean adding an error to a file that already carries 192.
      case 'access': return getIsSuperUser();
      // ponytail: legacy roleId===1 kept as a transitional OR-fallback so pre-RBAC
      // "Technical user" admins don't lose tiles; drop once everyone is on RBAC roles.
      default:                 return auth.hasPermission(FEATURE_BY_MODULE[moduleName]) || getRoleId() === 1;
    }
  }

  // Render only the tiles this user may access, chunked 3-per-Row to keep the
  // original grid alignment regardless of how many tiles are visible.
  renderTileRows = () => {
    const tiles = [
      {module: 'connection', icon: 'storage', title: 'Database Connection', desc: 'Manage your database connections.'},
      {module: 'query', icon: 'code', title: 'Database Queries', desc: 'Manage your database queries.'},
      {module: 'datasource', icon: 'source', title: 'Data Source', desc: 'Manage your data source used for rulesets.'},
      {module: 'datadictionary', icon: 'menu_book', title: 'Data Dictionary', desc: 'Manage your data dictionaries.'},
      {module: 'usergroup', icon: 'group_add', title: 'User Groups', desc: 'Manage your users & user groups.'},
      {module: 'rulesets', icon: 'rule', title: 'Manage Rulesets', desc: 'Manage your reconciliation rulesets.'},
      {module: 'delegations', icon: 'switch_account', title: 'My Delegations', desc: 'Hand off your data dictionary ownership to a backup while you\'re away.'},
      {module: 'userprofileadmin', icon: 'manage_accounts', title: 'User Profile Administration', desc: 'Manage user roles, permissions, and overrides.'},
      {module: 'access', icon: 'admin_panel_settings', title: 'Access Administration', desc: 'Grant, revoke and audit access-model roles and permissions.'},
    ].filter((t) => this.canAccess(t.module));

    const rows = [];
    for (let i = 0; i < tiles.length; i += 3) {
      rows.push(tiles.slice(i, i + 3));
    }

    return rows.map((rowTiles, idx) => (
      <Row className='extendable-height' key={idx}>
        {rowTiles.map((t) => (
          <Col sm={4} xs={6} key={t.module}>
            <div className='recon-results-card menu-card' data-testid={`settings-tile-${t.module}`} onClick={this.selectModule.bind(this, t.module)}>
              <span className="material-icons">{t.icon}</span>
              <h3>{t.title}</h3>
              <div className="desc">{t.desc}</div>
            </div>
          </Col>
        ))}
      </Row>
    ));
  }

   render() {

     const currentContext = getContext();

     // #622: don't blank /settings when context is disabled (currentContext is
     // always null then). When context is re-enabled this restores the original gate.
     if (CONTEXT_ENABLED && currentContext === null) {
       return null;
     }

     return (
       <div className={this.state.appContentContainer}>



       <div className={this.state.pageNavContainer}>
         <a onClick={this.goBack.bind(this,0)} className="back-link">
           <i className="material-icons">arrow_back</i>
           Manage Settings
         </a>
       </div>



        <div id='' className={this.state.mainPageClass}>
          <h2>Manage Settings</h2>
          {this.renderTileRows()}
        </div>


        <div className={this.state.subPageClass}>

        {this.state.showModule==="query" && this.canAccess('query') ? <DatabaseQuery parentNavBar={this.goBack.bind(this)} /> : null}

        {this.state.showModule==="connection" && this.canAccess('connection') ? <DatabaseConnection parentNavBar={this.goBack.bind(this)} /> : null}

        {this.state.showModule==="usergroup" && this.canAccess('usergroup') ? <AppUserGroups parentNavBar={this.goBack.bind(this)} /> : null}

        {this.state.showModule==="datasource" && this.canAccess('datasource') ? <DataSource parentNavBar={this.goBack.bind(this)} /> : null}

        {this.state.showModule==="datadictionary" && this.canAccess('datadictionary') ? (
          <DataDictionary
            parentNavBar={this.goBack.bind(this)}
            history={this.props.history}
            location={this.props.location}
            match={this.props.match}
          />
        ) : null}

        {this.state.showModule==="rulesets" && this.canAccess('rulesets') ? (
          <RuleSets
            parentNavBar={this.goBack.bind(this)}
            history={this.props.history}
            location={this.props.location}
            match={this.props.match}
          />
        ) : null}

        {this.state.showModule==="userprofileadmin" && this.canAccess('userprofileadmin') ? (
          <UserProfileAdmin
            parentNavBar={this.goBack.bind(this)}
            history={this.props.history}
          />
        ) : null}

        {this.state.showModule==="delegations" && this.canAccess('delegations') ? <MyDelegations embedded /> : null}

          {this.state.showModule === 'access' && this.canAccess('access') ? <AccessAdmin embedded /> : null}




        </div>



       </div>
     );
   }
}



export default SuperUserPanel;
